import TooltipComponent from "../TooltipComponent";

type ButtonTooltipIconType = {
    title: string,
    icon: string,
    onClick: () => void,
    colorIcon?:
    "text-primary" |
    "text-secondary",
    isLink?: boolean,
    style?: any,
    withTitle?: boolean
}

export const ButtonTooltipIcon = ({
    title,
    icon,
    onClick,
    colorIcon = "text-secondary",
    isLink = true,
    style,
    withTitle = false
}: ButtonTooltipIconType) => {
    return withTitle ? (
        <div className="dropdown dropdown-intiza ">
            <button className={"btn dropdown-toggle p-0 "} type="button">
                <div onClick={onClick} className={"select-intiza select-intiza-primary"}>
                    <span>
                        <i className={icon + ' me-2'}></i>
                        {title}
                    </span>
                </div>
            </button>
        </div>
    ) : (
        <TooltipComponent title={title}>
            <button type="button" className={"btn button-outline-primary"} style={style} onClick={onClick}>
                <i className={icon}></i>
            </button>
        </TooltipComponent>
    );
};


